import classNames from 'classnames';

import styles from './RawPicture.module.less';

type SourceMedia = {
    minWidth: number;
    height?: number;
    srcSet: string;
};

interface RawPictureProps {
    altText?: string;
    src?: string;
    height?: number;
    srcSet?: SourceMedia[];
    imgClassName?: string;
    className?: string;
    lazy?: boolean;
}

/**
 * Use this component for solving Art Direction problem in the images.
 * As opposed to RawImage component, browser will not download the image it thinks is the best - you tell it which image to download based on the viewport size size.
 */
const RawPicture = (props: RawPictureProps) => {
    const srcSet = props.srcSet?.sort((a, b) => b.minWidth - a.minWidth);

    return (
        <picture className={classNames(styles.Container, props.className)}>
            {srcSet?.map((item, index) => {
                return (
                    <source
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        media={`(min-width: ${item.minWidth}px)`}
                        srcSet={item.srcSet}
                        height={item.height}
                    />
                );
            })}
            <img
                loading={props.lazy ? 'lazy' : undefined}
                className={classNames(styles.Image, props.imgClassName)}
                src={props.src}
                alt={props.altText || ''}
                height={props.height}
            />
        </picture>
    );
};

export default RawPicture;
